import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=6b608f34&"
import script from "./Charges.vue?vue&type=script&lang=js&"
export * from "./Charges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports